module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"empty":"Пусто","leaveComment":"Оставить комментарий","goBack":"Назад"}}')
  delete Component.options._Ctor
}
